<template>
  <vs-card class="content-card" :class="{ disable: isDisconnect }">
    <div class="control">
      <div class="title-task">
        <div>
          <vs-icon icon="bolt" color="#5767FF"></vs-icon>
          <span>Breaker Control F.{{ device_id.slice(8) }}</span>
        </div>
        <div>
          <vs-icon
            @click="openPopup"
            class="btn-icon"
            icon="today"
            color="#5767FF"
          ></vs-icon>
          <vs-popup
            class="holamundo"
            title="Schedule Breaker"
            :active.sync="popupActivo"
            background-color-popup="var(--background-color-sidebar)"
          >
            <div class="add-schedule">
              <CardSchedule :schedule="schedule" :type="'view'" />
            </div>
          </vs-popup>
        </div>
      </div>
      <div class="switch1">
        <div>
          <img src="@/assets/images/i-APC/Light_on.png" alt="" v-if="switch1" />
          <img src="@/assets/images/i-APC/Light_off.png" alt="" v-else />
          <div class="bottom-hidden">
            <div class="off" @click="offlight"></div>
            <div class="on" @click="onlight"></div>
          </div>
          <vs-popup
            class="holamundo"
            title="Breaker trun off"
            :active.sync="BreakerPopupActivo"
            background-color-popup="var(--background-color-sidebar)"
          >
            <div class="popup-breaker">
              <h1>Are You Sure?</h1>
              <div class="layout-btn">
                <vs-button
                  color="danger"
                  type="filled"
                  @click="BreakerPopupActivo = false"
                  >NO</vs-button
                >
                <vs-button
                  color="success"
                  type="filled"
                  @click="confrimOfflight"
                  >YES</vs-button
                >
              </div>
            </div>
          </vs-popup>
        </div>
      </div>
    </div>
  </vs-card>
</template>

<script>
import CardSchedule from "./CardSchedule.vue";

export default {
  props: {
    device_id: {
      type: String,
      default: undefined,
    },
    schedule: {
      type: [Array, Object],
      default: [],
    },
  },
  data() {
    return {
      switch1: true,
      popupActivo: false,
      isDisconnect: true,
      interval: null,
      BreakerPopupActivo: false,
    };
  },
  components: {
    CardSchedule,
  },
  async mounted() {
    // await this.getStatus();
    // if (this.interval != null) {
    //   clearInterval(this.interval);
    // }
    // this.interval = setInterval(async () => {
    //   await this.getStatus();
    // }, 20 * 1000);
    await this.callData()
  },
  beforeDestroy() {
    console.log("beforeDestroy");
    clearTimeout(this.interval);
  },
  methods: {
    async callData() {
      await this.getStatus();
      this.interval = setTimeout(async () => {
        await this.callData();
      }, 20 * 1000);
    },
    async getStatus() {
      let res = await this.$API.get("tuya/breaker/status/" + this.device_id);
      console.log(this.device_id, res);
      if (res.status === 200 && res.data.success == true) {
        this.switch1 = res.data.result[0].value;
        this.isDisconnect = !res.data.success;
      } else {
        this.isDisconnect = true;
      }
    },
    async onlight() {
      console.log("click");
      // this.play();
      this.switch1 = true;

      let body = {
        device: this.device_id,
        value: this.switch1,
      };
      console.log(body);
      // call close breaker
      let res = await this.$API.post("tuya/breaker/command", body);
      console.log(res);
      if (res.status === 200) {
        if (res.data.success != true) {
          this.switch1 = !this.switch1;
        }
      }
    },
    offlight() {
      // this.play();
      this.BreakerPopupActivo = true;
    },
    async confrimOfflight() {
      this.switch1 = false;
      let body = {
        device: this.device_id,
        value: this.switch1,
      };
      console.log(body);
      // call close breaker
      let res = await this.$API.post("tuya/breaker/command", body);
      console.log(res);
      if (res.status === 200) {
        if (res.data.success != true) {
          this.switch1 = !this.switch1;
        }
      }

      this.BreakerPopupActivo = false;
    },
    openPopup() {
      this.$store.dispatch("i_APC/genData");
      this.$store.dispatch("i_APC/getSchedule");
      this.popupActivo = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-card {
  // background: #ff0000;
}
.control {
  display: flex;
  flex-direction: column;
  .switch1 {
    margin: 42.5px 5px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 5px;
    .bottom-hidden {
      width: 200px;
      height: 55px;
      display: flex;
      //   background: rgba(35, 7, 161, 0.11);
      position: relative;
      .off {
        width: 70px;
        height: 55px;
        // background: rgba(255, 0, 0, 0.11);
        margin-left: 30px;
        cursor: pointer;
      }
      .on {
        width: 70px;
        height: 55px;
        // background: rgba(60, 255, 0, 0.11);
        cursor: pointer;
      }
    }
  }
  .title-task {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    div {
      span {
        margin-left: 5px;
        color: #5767ff;
      }
    }
  }
}
img {
  width: 200px;
  position: absolute;
}
.btn-icon {
  cursor: pointer;
}
.disable {
  background-color: #7c7c7c8c;
  .control {
    .switch1 {
      pointer-events: none;
    }
  }
}
.popup-breaker {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  .layout-btn {
    display: flex;
    gap: 20px;
  }
}
</style>